import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../firebase";

/**
 * Uploads a file to Firebase Storage under the path:
 * "admin/training_files/{folderId}/{fileName}"
 *
 * @param {File} file - The file to upload
 * @param {string} folderId - The ID of the folder to upload the file into
 * @param {(progress: number) => void} onProgress - Optional callback for upload progress (0-100)
 * @returns {Promise<string>} - Resolves with the download URL of the uploaded file
 */
export function uploadFileToFolder(file, folderId, departmentId, onProgress) {
  return new Promise((resolve, reject) => {
    if (!file || !folderId) {
      reject(new Error("File and folderId are required for upload."));
      return;
    }

    const storagePath = `admin/training_files/${folderId}/${file.name}`;
    const storageRef = ref(storage, storagePath);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        if (onProgress) {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(progress);
        }
      },
      (error) => {
        reject(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          resolve(downloadURL);
        });
      }
    );
  });
}
